import React from "react"
import DataTable from "ui/DataTable"
import PropTypes from "prop-types"
import { crewMembersColumns } from "./columns"

const CrewMembersTable = ({ data, onChange, loading }) => {
    return <DataTable columns={crewMembersColumns} dataSource={data} pagination={false} onChange={onChange} loading={loading} />
}

CrewMembersTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    loading: PropTypes.bool
}

export { crewMembersColumns as columns }
export default React.memo(CrewMembersTable)
